import * as Constants from '../constants';
import { getInDomain } from '../domains/externalUtils';
import createActionMapping from '../lib/ActionRouter';

let stationNarrativeTimer;

/**
 * Handles User action IS_STATION_NARRATIVE_DISPLAYED
 *
 * @param  {object} action - the current action
 * @param  {object} store - the dispatch and getState methods of the store
 * @param store.dispatch
 * @param store.getState
 * @param  {object} next - the next dispatch function
 * @returns {Promise} allow caller to chain & handle completion
 */
export function onShowNarrative(action, { dispatch, getState }, next) {
  clearTimeout(stationNarrativeTimer);
  if (action.data.doShow) {
    stationNarrativeTimer = window.setTimeout(() => {
      const hideStationNarrativeAction = getInDomain(
        'playback.actions.hideStationNarrative',
        null,
      )();
      if (hideStationNarrativeAction) {
        dispatch(hideStationNarrativeAction);
      }
    }, Constants.Timers.STATION_NARRATIVE_TIMEOUT);
  }
  return next(action);
}

export const route = createActionMapping({
  [Constants.Playback.ActionTypes.IS_STATION_NARRATIVE_DISPLAYED]: onShowNarrative,
});

/**
 * Pass incoming actions to ActionRouter
 *
 * @param  {object} store - redux
 * @param  {object} next - dispatch function of next middleware in the chain
 * @param  {object} action - the current action
 * @returns {Promise} resolution of the workflow
 */
export default store => next => action => {
  return route(action, store, next);
};
